import { AlpineData, LivewireData, LivewireMethods } from "@/js/interfaces/Components/alpinejs/User/TemporaryMessage";
import { createAlpineLivewireComponent } from "@nolikein/typed-alpinejs";

/* Generated from the "artisan make:alpine" command */
export default {
    name: 'TemporaryMessage',
    component: (
        // Component parameters...
        duration = 1500,
    ) => createAlpineLivewireComponent<AlpineData, LivewireData, LivewireMethods>({
        // Component properties ...
        display: false,
        duration: duration,
        timeId: null,

        displayMessage() {
            this.display = true;

            if (null !== this.timeId) {
                clearTimeout(this.timeId);
            }
            this.timeId = setTimeout(() => {
                this.display = false;
            }, this.duration);
        },
    }),
};
